const EMPTY_VALUE = "";

const isPlainObject = (value) =>
  value != null && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date);

const normalizeCellValue = (value) => {
  if (value == null) return EMPTY_VALUE;
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value) || isPlainObject(value)) return JSON.stringify(value);
  return String(value);
};

const escapeCsvCell = (value) => {
  const normalized = normalizeCellValue(value);
  if (/[",\r\n]/.test(normalized)) {
    return `"${normalized.replace(/"/g, '""')}"`;
  }
  return normalized;
};

const collectHeaders = (rows) => {
  const seen = new Set();
  rows.forEach((row) => {
    Object.keys(row || {}).forEach((key) => seen.add(key));
  });
  return Array.from(seen);
};

const buildCsv = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const headers = collectHeaders(safeRows);
  if (headers.length === 0) return "";
  return [
    headers.map(escapeCsvCell).join(","),
    ...safeRows.map((row) => headers.map((header) => escapeCsvCell(row?.[header])).join(",")),
  ].join("\r\n");
};

const timestampForFile = () => {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return [
    now.getFullYear(),
    pad(now.getMonth() + 1),
    pad(now.getDate()),
    pad(now.getHours()),
    pad(now.getMinutes()),
    pad(now.getSeconds()),
  ].join("");
};

export const downloadCsv = (baseName, rows) => {
  const csv = buildCsv(rows);
  if (!csv) return false;

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${baseName}-${timestampForFile()}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
};

export const downloadJson = (baseName, value, { pretty = true } = {}) => {
  const blob = new Blob([JSON.stringify(value, null, pretty ? 2 : undefined)], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${baseName}-${timestampForFile()}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return true;
};
